import { prefersReducedMotion } from './reduced-motion';

let borderAnimationsInitialized = false;

const fadeIntersectionCallback = (entries, observer) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            entry.target.classList.remove('opacity-0');
            entry.target.classList.add('opacity-1');
            observer.unobserve(entry.target);
        }
    });
};

const allLineEls = [];

const borderIntersectionCallback = (entries, observer) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            setTimeout(() => {
                entry.target.addEventListener('transitionend', () => {
                    const elFromSource = allLineEls.find(
                        (el) => el.el === entry.target,
                    );

                    entry.target.parentElement.classList.add(
                        `line-loaded-${elFromSource.position}`,
                    );
                    entry.target.classList.add('hidden');
                });

                if (
                    entry.target.classList.contains('animated-line-horizontal')
                ) {
                    entry.target.classList.add('!scale-x-100');
                } else {
                    entry.target.classList.remove('opacity-0');
                    entry.target.classList.add('!scale-y-100');
                }

                observer.unobserve(entry.target);
            }, 250);
        }
    });
};

const animatedLineTop = document.querySelector('#animated-line-top');
const animatedLineBottom = document.querySelector('#animated-line-bottom');
const animatedLineRight = document.querySelector('#animated-line-right');
const animatedLineLeft = document.querySelector('#animated-line-left');

const fadeObserver = new IntersectionObserver(fadeIntersectionCallback, {
    rootMargin: '0px',
    threshold: 0.25,
});

const borderObserver = new IntersectionObserver(borderIntersectionCallback, {
    rootMargin: '0px',
    threshold: 0.5,
});

const fixAndObserveBorderElement = (
    el,
    template,
    position,
    additionalClasses = [],
) => {
    if (!el.classList.contains('absolute')) {
        // Give it some sort of position to be absolute against
        el.classList.add('relative');
    }

    const lineEl = template.content.firstElementChild.cloneNode(true);

    additionalClasses.forEach((cl) => lineEl.classList.add(cl));

    el.prepend(lineEl);

    allLineEls.push({
        el: lineEl,
        position,
    });

    borderObserver.observe(lineEl);
};

const handleBorderEls = (
    elClass,
    template,
    position,
    additionalClasses = [],
) => {
    document
        .querySelectorAll(`.${elClass}`)
        .forEach((el) =>
            fixAndObserveBorderElement(
                el,
                template,
                position,
                additionalClasses,
            ),
        );
};

export const initBorderAnimations = () => {
    if (prefersReducedMotion || borderAnimationsInitialized) {
        return;
    }

    borderAnimationsInitialized = true;

    handleBorderEls('border-b', animatedLineBottom, 'bottom');
    handleBorderEls('small-desktop\\:border-b', animatedLineBottom, 'bottom', [
        'hidden',
        'small-desktop:block',
    ]);
    handleBorderEls('small-desktop\\:border-t', animatedLineTop, 'top', [
        'hidden',
        'small-desktop:block',
    ]);
    handleBorderEls('border-t', animatedLineTop, 'top');
    handleBorderEls('border-r', animatedLineRight, 'right');
    handleBorderEls(
        'small-desktop\\:odd\\:border-r',
        animatedLineRight,
        'right',
        ['hidden', 'small-desktop:block'],
    );
    handleBorderEls('border-l', animatedLineLeft, 'left');

    document.querySelectorAll('.odd, .even, .middle').forEach((el) => {
        const leftBorder = getComputedStyle(el, null).getPropertyValue(
            'border-left-width',
        );

        const rightBorder = getComputedStyle(el, null).getPropertyValue(
            'border-right-width',
        );

        if (leftBorder !== '0px') {
            fixAndObserveBorderElement(el, animatedLineLeft, 'left');
        }

        if (rightBorder !== '0px') {
            fixAndObserveBorderElement(el, animatedLineRight, 'right');
        }
    });
};

export const initPageAnimations = () => {
    if (prefersReducedMotion) {
        return;
    }

    const fadeInEls = document.querySelectorAll('.fade-in-on-scroll');

    fadeInEls.forEach((el) => {
        el.classList.add('opacity-0', 'transition-opacity', 'duration-500');
        fadeObserver.observe(el);
    });

    initBorderAnimations();
};
